import { Component,  OnDestroy,  OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseUpdateComponent } from '@app/shared/components/base/base-update.component';
import {
    CaseNoSettings, CaseNoStructure, CaseNumberStructureLevel,
    CaseNumberStructureLevels
} from '@app/shared/models/case-number-settings';
import { CaseNoSettingsUriBuilderParams,  CaseNumberService } from '@app/core/services/case-number.service';
import { TranslationEntry } from '@app/shared/models/translatable';

@Component({ 
    templateUrl:  './case-number-management.component.html', 
    styleUrls:  ['./case-number-management.component.scss']
})
export class CaseNumberManagementComponent extends BaseUpdateComponent<CaseNoSettings,  CaseNoSettingsUriBuilderParams>
                                           implements OnInit,  OnDestroy { 

    protected paramsIdNames = [];

    get caseNumberStructureSettings() {
        return this.updated;
    }

    public availableStructureLevels: TranslationEntry[];

    get selectedLevel() {
        return this.caseNumberStructureSettings && CaseNumberStructureLevels.getByKey(this.caseNumberStructureSettings.base_level);
    }

    set selectedLevel(level: TranslationEntry) {
        this.caseNumberStructureSettings.base_level = level.key as CaseNumberStructureLevel;
        this.update('', () => {
            this.selectFirstListEntry();
        });
    }

    get selectedLevelStructureList(): CaseNoStructure[] {
        return this.getSelectedLevelStructureList(this.caseNumberStructureSettings);
    }

    public selectedStructureId: string;
    public selected: CaseNoStructure;

    protected getSelectedLevelStructureList(structureSettings: CaseNoSettings): CaseNoStructure[] {
        return structureSettings ? structureSettings.getStructureListByLevel(this.selectedLevel && this.selectedLevel.key as CaseNumberStructureLevel) : [];
    }

    constructor(protected componentServiceBundle:  ComponentServiceBundle,  protected caseNumberService:  CaseNumberService ) {
        super(componentServiceBundle,  caseNumberService);
        this.myConfig.fetchAtInit = true;
        this._idPrefix = 'settings-case-number-management.';
    }

    public ngOnInit() { 
        super.ngOnInit();
    }

    public ngOnDestroy() { 
        super.ngOnDestroy();
    }

    protected whenOriginalFetched(): void {
        super.whenOriginalFetched();
        this.availableStructureLevels = CaseNumberStructureLevels.ALL.filter(level => this.structureLevelIsAvailable(level));
        this.selectFirstListEntry();
    }

    protected structureLevelIsAvailable(level: TranslationEntry): TranslationEntry {
        return this.caseNumberStructureSettings && this.caseNumberStructureSettings.available_levels.find(availableLevel => availableLevel === level.key) ? level : null;
    }

    protected selectFirstListEntry(): void {
        if (this.selectedLevelStructureList.length > 0) {
            this.select(this.selectedLevelStructureList[0]);
        }
    }

    protected generateUriBuilderParams():  CaseNoSettingsUriBuilderParams { 
        return new CaseNoSettingsUriBuilderParams();
    }

    public select(structure: CaseNoStructure): void {
        this.selectedStructureId = structure && structure.reference_id;
        this.selected = new CaseNoStructure(this.caseNumberStructureSettings.getStructure(this.selectedLevel && this.selectedLevel.key as CaseNumberStructureLevel, this.selectedStructureId));
    }

    public cancel(): void {
        this.select(this.selected);
    }

    public save(updatedStructure: CaseNoStructure): void {
        this.caseNumberStructureSettings.setStructure(this.selectedLevel && this.selectedLevel.key as CaseNumberStructureLevel, this.selectedStructureId, updatedStructure);
        this.update('', () => {
            this.showSuccessSnackBar();
        });
    }

    public showSuccessSnackBar(): void {
        this.showSimpleConfirmSnackbar(marker('case_number_management.msg.case_number_structure_saved'));
    }
}
